import type { File } from './files';

//needed for zod
export const TRAINING_STATUS_VALUES = [
  'VALID',
  'EXPIRED',
  'EXPIRE_SOON',
  'CLEARED_SUPERSEEDED',
  'CLEARED',
] as const;

export enum TrainingStatusEnum {
  VALID = 'VALID',
  EXPIRED = 'EXPIRED',
  EXPIRE_SOON = 'EXPIRE_SOON',
  CLEARED_SUPERSEEDED = 'CLEARED_SUPERSEEDED',
  CLEARED = 'CLEARED',
}

export type TrainingStatus = (typeof TRAINING_STATUS_VALUES)[number];

export type TrainingUser = {
  id: number;
  firstName: string;
  lastName: string;
  email: string | null;
};

export type Training = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  description: string | null;
  date: Date;
  expiryDate: Date | null;
  status: TrainingStatus;
  // relations
  organizationId: number;
  userId: number;
  user: TrainingUser;
  files: File[];
};
